import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types'
export const EmployeeAttendanceContext = createContext();

export const EmployeeAttendance= ({ children }) => {
    const [employeeAttendance, setEmployeeAttendance] = useState(null);
    return (
        <EmployeeAttendanceContext.Provider value={{employeeAttendance, setEmployeeAttendance}}>
            {children}
        </EmployeeAttendanceContext.Provider>
    );
};

EmployeeAttendance.propTypes = {
    children: PropTypes.node.isRequired
};
